var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpousePartTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 97,
    height: 35,
    viewBox: "0 0 97 35",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "spousePartTime-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 35,
    transform: "translate(-30 1)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "spousePartTime",
    transform: "translate(30 -1)",
    clipPath: "url(#spousePartTime-clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5,35A16.5,16.5,0,1,0,2,18.5,16.5,16.5,0,0,0,18.5,35Z",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6,27.463l6.9-3.271v-9.67",
    transform: "translate(-7.998 -5.692)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6,27.463l6.9-3.271v-9.67",
    transform: "translate(-7.998 -5.692)",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.795,33.993l-.018.541c-.068,0-.135,0-.2-.007l.037-.548.066.005h.005ZM27.262,32.4l.265.459q-.079.042-.16.087l-.244-.47.068-.037h0ZM14.3,32.153l-.255.443-.088-.051,0,0-.082-.048.274-.429C14.2,32.1,14.247,32.125,14.3,32.153ZM32.522,28.1l-.043.075-.447-.275c.03-.05.058-.1.085-.149l.456.263-.048.083ZM9.645,27.269l-.484.3c-.033-.06-.064-.121-.095-.184l.5-.259.037.068v0Zm24.89-6.063c0,.093,0,.18-.008.264l-.548-.036.005-.066v-.005c0-.05.008-.1.011-.156ZM7.511,20.768c0-.065,0-.129.007-.192l.56.037H7.511ZM32.94,14.62l-.493.237-.041-.075v0l-.038-.07.477-.275C32.878,14.5,32.909,14.557,32.94,14.62ZM9.9,14.305l-.453-.261.051-.088,0,0,.048-.082.44.281C9.96,14.2,9.931,14.256,9.9,14.305ZM28.139,9.552l-.274.429c-.051-.031-.1-.06-.154-.087l.255-.442.088.051,0,0ZM14.472,9.2c.062-.034.125-.067.191-.1l.241.465q-.088.039-.171.086Zm7-1.683-.036.525h-.156V7.511C21.343,7.512,21.406,7.514,21.469,7.518Z",
    transform: "translate(-2.505 -2.505)",
    fill: "none",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpousePartTime);
export default __webpack_public_path__ + "static/media/spousePartTime.865200a71a143eb97b9b29db50c58644.svg";
export { ForwardRef as ReactComponent };